import {
  DashboardBasicAccountApplicationDocument,
  DashboardCardApplicationDocument,
} from "../../api/commercial/generated-types";

export const PAGE_SIZE = 10;

export interface DashboardModel {
  cardApplications: DashboardCardApplicationDocument[];
  basicAccountApplications: DashboardBasicAccountApplicationDocument[];
}
